import React, { useEffect, useState } from 'react';
import MiddlePanel from 'Components/MiddlePanel/MiddlePanel';
import Panel from 'Components/Panel/Panel';
import LoadingIndicator from 'Components/LoadingIndicator/LoadingIndicator';
import Operations from 'pages/Suppliers/Operations/Operations';
import ExecuteAxios from 'Components/ExecuteAxios/ExecuteAxios';

const NewOperationSupplier = ({
    onUpdateShowNewOperationSupplier,
    showNewOperationSupplier,
    productIdSelected
}) => {
    const [supplierIdSelected, setSupplierIdSelected] = useState(false);
    const [loadingNewOperationSupplier, setLoadingNewOperationSupplier] = useState(false);

    async function getSupplerId() {
        try {
            setLoadingNewOperationSupplier(true)
            const parameters = { id: productIdSelected[0] }
            return await ExecuteAxios.api('get', `/product/get-supplier-id-by-product-id/`, { params: parameters })
        } finally {
            setLoadingNewOperationSupplier(false)
        }
    }


    useEffect(() => {
        const onReady = async () => {
            if (showNewOperationSupplier && productIdSelected && productIdSelected.length === 1) {
                setSupplierIdSelected(await getSupplerId())
            }
        };

        onReady();
    }, [productIdSelected, showNewOperationSupplier])

    return (
        <MiddlePanel isVisible={showNewOperationSupplier}>
            <LoadingIndicator loaded={!loadingNewOperationSupplier && supplierIdSelected}>
                <Panel
                    style={{
                        width: '1000px',
                        height: '600px',
                        borderRadius: '10px',
                        backgroundColor: '#f5f5f5;',
                        border: '1px solid #ccc',
                        boxShadow: '0px 0px 10px rgba(0, 0, 0, 0.3)',
                        displey: 'flex',
                        flexDirection: 'column'
                    }}
                    titlePage={'Adicionar operação para o fornecedor do produto'}
                    canViewCRUD={true}
                    deleteFunction={() => {
                        onUpdateShowNewOperationSupplier(false)
                    }}
                    deleteNameButton='Fechar'
                    enableDelete={true}
                    canDelete={true}
                >
                    <Operations
                        onUpdateOperationIdSelected={() => { }}
                        onUpdateReloadListOperation={() => { }}
                        operationIdSelected={[]}
                        supplierIdSelected={[supplierIdSelected]}
                        operationsListFilter={null}
                        insertingForced={true}
                    />
                </Panel>
            </LoadingIndicator>
        </MiddlePanel>
    );
};

export default NewOperationSupplier;
